import styled from 'styled-components';
import Headroom from "react-headroom/dist";

const BottomHeadroom = styled(({className, children, ...props}) => (
    <Headroom disableInlineStyles className={className} {...props}>
        {children}
    </Headroom>
))`
  .headroom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .headroom--unfixed, .headroom--pinned {
    transform: translateY(0%);
  }

  .headroom--unpinned {
    transform: translateY(56px); // height of BottomBar
  }

  .headroom--unfixed, .headroom--scrolled, .headroom--unpinned {
    transition: transform 200ms ease-in-out;
  }
`;

export default BottomHeadroom;
